import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import NoInternetConnectionModal from 'Components/NoInternetConnectionModal';
import { useNetworkStatusProvider } from 'Context/NetworkStatusProvider';

const InternetConnection = () => {
  const history = useHistory();
  const { isOnline, handleCheckInternet } = useNetworkStatusProvider();
  const [isLoading, setIsLoading] = useState(false);

  const handleInternetConnected = async () => {
    setIsLoading(true);
    const isInternetConnected = await handleCheckInternet();

    setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    if (isInternetConnected) {
      history.go(0);
    }
  };

  if (!isOnline) {
    return (
      <NoInternetConnectionModal isOpen isLoading={isLoading} onClose={handleInternetConnected} />
    );
  }

  return null;
};

export default InternetConnection;
